import React from "react"
import CustomImage from "@/main/customImage"

import { Card, Row, Col, Accordion } from "react-bootstrap"

function FullDetails({ property }) {
    return (
        <>
            <Col xs={12} as={Card} className="rounded-0 mt-5">
                <Card.Body>
                    <Card.Title>
                        <h2 className="text-center">Full details</h2>
                    </Card.Title>
                </Card.Body>
            </Col>
            <Col xs={12} as={Card} className="rounded-0 mt-4">
                {/* Full Details */}
                <Card.Body>
                    <Row>
                        <Col xs={12}>
                            <p>{property.description}</p>
                            <div className="d-flex flex-row-reverse">
                                <span className="text-wjlightgrey">
                                    Click &lsquo;+&rsquo; below to expand
                                    details where available
                                </span>
                            </div>

                            <Accordion>
                                {property.room_details?.map((room_detail) => {
                                    // Full Details That Have Description
                                    return room_detail.description !== "" ? (
                                        <Accordion.Item
                                            key={room_detail.id}
                                            eventKey={room_detail.id}
                                            className="mb-2"
                                        >
                                            <Accordion.Header
                                                as="h3"
                                                id={"heading-" + room_detail.id}
                                            >
                                                <span className="h6">
                                                    {room_detail.name}
                                                </span>
                                                <span className="text-sm mb-2 ms-3">
                                                    {room_detail.dimensions}
                                                </span>
                                                <div className="collapse-close position-absolute end-0 me-3">
                                                    <CustomImage
                                                        src={
                                                            "https://webb-jenkins-static-164679926.imgix.net/icons/plus-icon.svg"
                                                        }
                                                        alt="Plus icon"
                                                        height={16}
                                                        width={16}
                                                        className="collapse-close"
                                                    />
                                                </div>
                                                <div className="collapse-open position-absolute end-0 me-3">
                                                    <CustomImage
                                                        src={
                                                            "https://webb-jenkins-static-164679926.imgix.net/icons/minus-icon.svg"
                                                        }
                                                        alt="Minus icon"
                                                        height={16}
                                                        width={16}
                                                    />
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="opacity-8">
                                                    <p>
                                                        {
                                                            room_detail.description
                                                        }
                                                    </p>
                                                </div>
                                            </Accordion.Body>
                                            <hr />
                                            {/* Full Details That Have Description End */}
                                        </Accordion.Item>
                                    ) : (
                                        // Full Details That Don't Have Description
                                        <Accordion.Item
                                            key={room_detail.id}
                                            className=" mb-2"
                                        >
                                            <Accordion.Header
                                                as="h3"
                                                id={"heading-" + room_detail.id}
                                            >
                                                <span className="h6">
                                                    {room_detail.name}
                                                </span>
                                                <span className="text-sm mb-2 ms-3">
                                                    {room_detail.dimensions}
                                                </span>
                                            </Accordion.Header>
                                            <hr />
                                        </Accordion.Item>
                                        // Full Details That Don't Have Description End
                                    )
                                })}
                                {property.documents?.map((document) => {
                                    return document.document_text === "EPC" &&
                                        document.imgix_url ? (
                                        <Accordion.Item
                                            key="EPCAccordion"
                                            eventKey="EPCAccordion"
                                            className="mb-2"
                                        >
                                            <Accordion.Header
                                                as="h3"
                                                id="heading-EPCAccordion"
                                            >
                                                <span className="h6">EPC</span>

                                                <div className="collapse-close position-absolute end-0 me-3">
                                                    <CustomImage
                                                        src={
                                                            "https://webb-jenkins-static-164679926.imgix.net/icons/plus-icon.svg"
                                                        }
                                                        alt="Plus icon"
                                                        height={16}
                                                        width={16}
                                                        className="collapse-close"
                                                    />
                                                </div>
                                                <div className="collapse-open position-absolute end-0 me-3">
                                                    <CustomImage
                                                        src={
                                                            "https://webb-jenkins-static-164679926.imgix.net/icons/minus-icon.svg"
                                                        }
                                                        alt="Minus icon"
                                                        height={16}
                                                        width={16}
                                                    />
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body className="epc-div">
                                                <CustomImage
                                                    src={document.imgix_url}
                                                    alt={`Property ${property.property_ref} EPC`}
                                                    layout="responsive"
                                                    width={1098}
                                                    height={613}
                                                    sizes="50vw"
                                                />
                                            </Accordion.Body>
                                            <hr />
                                            {/* Full Details That Have Description End */}
                                        </Accordion.Item>
                                    ) : null
                                })}
                            </Accordion>
                        </Col>
                    </Row>
                </Card.Body>
                {/* Full Details End */}
            </Col>
        </>
    )
}

export default FullDetails
